import { useEffect, useState } from "react";
import "./Blog.css";
import { useNavigate } from "react-router-dom";

const Blog = ({ white, Blogs }) => {
  const image = "https://imgs.search.brave.com/_6izdbSVpHbwqbawMBquENAqLf6WtvwCZmTG8AhitpY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4t/ZnJvbnQuZnJlZXBp/ay5jb20vaG9tZS9h/bm9uLXJ2bXAvY3Jl/YXRpdmUtc3VpdGUv/cGhvdG9ncmFwaHkv/Y2hhbmdlLWxvY2F0/aW9uLndlYnA";
  const [blogs, setBlogs] = useState([]);
  const [expand, setExpand] = useState(false);

  const LinkTo = useNavigate();

  useEffect(() => {
    if (expand) {
      setBlogs(Blogs);
    }
    else {
      const fourBlogs = Blogs.length > 4 ? Blogs.slice(0, 4) : Blogs;
      setBlogs(fourBlogs);

    }
  }, [expand]);

  

  return (
    <>
      {/* <BlogPreview/> */}

      <div className={`blogPage ${white}`}>
        <div className="introText">
          <p className={white}>Stay Updated<br /> With Our Latest Blogs</p>
          <p>Learn, Create, Grow</p>
        </div>

        <div className="blogsList">
          {blogs.map((blg, index) =>
            <div data-aos="zoom-in" onClick={() => LinkTo(`/blog/${blg.website.id}`)} key={index} className={`blog ${white}`}>
              <section><p className={white}>Blog {blg.website.id}</p></section>
              <section>
                <p className={white}>{blg.website.date} </p>
                <p className={white} > {blg.website.title} </p>
              </section>
              <section>
                <p className={white}>Category</p>
                <p className={white}>{blg.website.catogery} </p>
              </section>
              <section>
                <div className="img">
                  <img src={blg.website.author.image} alt={blg.website.title} />
                </div>
              </section>
            </div>
          )}
          {Blogs.length > 4 &&
            <div data-aos="zoom-in" className="blog">
              <section><p className={white}>d</p></section>
              <section>
                <p className={white}>d </p>
                <p className={white} > d </p>
              </section>
              <section>
                <p className={white}>Category</p>
                <p className={white}>d</p>
              </section>
              <section>
                <div className="img">
                  <img src="" alt="sdad" />
                </div>
              </section>
            </div>
          }

          {Blogs.length > 4 ?
            <>
              <div className="closeBtn">
                <button className={`scrollBtn ${white}`} onClick={() => setExpand(!expand)}><span>{expand ? "Show less blog" : "Explore all blog"}</span><span>{expand ? "Show less blog" : "Explore all blog"}</span> </button>
              </div></> :

            <>

            </>}

        </div>
      </div>
    </>
  )
}
export default Blog;